import { Product } from './AppConstants';

export const rootPath = '/';

const sfBasePath = `/${Product.SETTLEMENT_FINANCE.toLowerCase()}`;
const ifBasePath = `/${Product.INVESTMENT_FINANCE.toLowerCase()}`;

export const ProductRoutesBasePath = '/:productId';
export const PrivacyPolicyPath = '/:lang/privacy-policy';
export const CookiePolicyPath = '/:lang/cookie-policy';
export const TermsAndConditionsPath = '/if/terms-and-conditions'; // bahasa terms and conditions

export const getPrivacyPolicyPath = (lang: string) => `/${lang}/privacy-policy`;
export const getCookiePolicyPath = (lang: string) => `/${lang}/cookie-policy`;

export const SettlementFinanceRoutes = {
  basePath: `${sfBasePath}`,
  createSubmission: `${sfBasePath}/submission/create`,
  submitRepayment: `${sfBasePath}/repayment/submit`,
  confirmRepayment: `${sfBasePath}/repayment/confirm`,
  pendingDisbursement: `${sfBasePath}/disbursement/pending`,
  downloadPendingDisbursement: `${sfBasePath}/disbursement/approved`,
  previousLoans: `${sfBasePath}/loan/submission/history`,
  disbursementHistory: `${sfBasePath}/loan/disbursement/history`,
};

export const InvestmentFinanceRoutes = {
  basePath: `${ifBasePath}`,
  submissions: `${ifBasePath}/submissions`,
  createSubmission: `${ifBasePath}/submission/create`,
  createSubmissionStep2: `${ifBasePath}/submission/create/step2`,
  submissionApproval: `${ifBasePath}/submission/approval`,
  submissionApprovalWithId: `${ifBasePath}/submission/approval/:id`,
  termsAndConditions: `${ifBasePath}/terms-and-conditions`,
  previousLoans: `${ifBasePath}/previous-loans`,
  uploadDocs: `${ifBasePath}/previous-loans/upload-documents`,
  loanHistory: `${ifBasePath}/loan-history`,
  repayments: `${ifBasePath}/repayments`,
};
